export default "__VITE_ASSET__BRm90dyf__"